import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'autoDebitPayment',
    label: 'Auto Debit Payment',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const paymentInformationForm = {
  name: FormNames.POST_CLOSING,
  label: 'Payment Information',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
